import "@/utils/extensions/libs/NumberExtension";
import Arrays from "@/utils/extensions/Arrays";

export function toExcelColumnLabel(digit: number) {
  const result = digit.radix(27);
  // 末位不能是 0 如果是 0 自动升为 1   因为0在最后转字符串时没有意义
  return result
    .map((it: number, index: number) => {
      if (index === 0) {
        return String.fromCharCode((it || 1) + 64);
      }
      return String.fromCharCode(it + 65);
    })
    .join("");
}
